import * as locales from '@mui/material/locale';
import { createTheme } from '@mui/material/styles';
import _ from 'lodash';
import components from './Components';
import { DarkThemeColors } from './DarkThemeColors';
import { baseDarkTheme, baselightTheme } from './DefaultColors';
import { LightThemeColors } from './LightThemeColors';
import { darkshadows, shadows } from './Shadows';
import typography from './Typography';

// Default theme configuration
export const defaultThemeConfig = {
  activeMode: 'light',
  activeTheme: 'BLUE_THEME',
  activeDir: 'ltr',
  borderRadius: 7,
  isLanguage: 'enUS',
};

export const buildTheme = (config = defaultThemeConfig) => {
  const themeOptions = LightThemeColors.find((theme) => theme.name === config.activeTheme) || {};
  const darkthemeOptions = DarkThemeColors.find((theme) => theme.name === config.activeTheme) || {};
  const defaultTheme = config.activeMode === 'dark' ? baseDarkTheme : baselightTheme;
  const defaultShadow = config.activeMode === 'dark' ? darkshadows : shadows;
  const themeSelect = config.activeMode === 'dark' ? darkthemeOptions : themeOptions;
  const baseMode = {
    palette: {
      mode: config.activeMode,
    },
    shape: {
      borderRadius: config.borderRadius,
    },
    shadows: defaultShadow,
    typography: typography,
  };

  const theme = createTheme(
    _.merge({}, baseMode, defaultTheme, locales[config.isLanguage] || {}, themeSelect, {
      direction: config.activeDir,
    }),
  );

  theme.components = components(theme);
  return theme;
};

// This is now just a named export for backward compatibility
export const ThemeSettings = () => buildTheme(defaultThemeConfig);
